// DEPENDENCIES
import React, { useState, useContext } from "react";

// CSS
import "./AddAdminJobTitleDialog.css";

// MSAL
import { useMsal } from "@azure/msal-react";

// API IMPORTS
import { postAPICall } from "../../../../config/apiCalls";

// CONTEXT
import { UserContext } from "../../../../context/UserContext";

// MUI COMPONENTS
import {
	Alert,
	Autocomplete,
	Button,
	CircularProgress,
	Collapse,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AddAdminJobTitleDialog = ({ open, availableJobTitles, onClose, onAdded }) => {
	const { instance, accounts } = useMsal();
	const employeeID = useContext(UserContext);

	const [selected, setSelected] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [alertOpen, setAlertOpen] = useState(false);

	const handleClose = () => {
		setSelected(null);
		setAlertOpen(false);
		onClose();
	};

	const handleSubmit = async () => {
		if (!selected) {
			setAlertOpen(true);
			return;
		}

		setIsLoading(true);
		try {
			await postAPICall(
				instance,
				accounts[0],
				"/api/workload/admin-job-titles",
				{ job_title_id: selected.id, modified_by: employeeID }
			);
			handleClose();
			onAdded();
		} catch (err) {
			console.error("Error adding admin job title:", err);
		}
		setIsLoading(false);
	};

	return (
		<Dialog
			id="AddAdminJobTitleDialog"
			open={open}
			fullWidth
			maxWidth="sm"
			onClose={handleClose}
		>
			<DialogTitle id="AddAdminJobTitleDialogTitle">
				Add Admin Job Title
			</DialogTitle>
			<DialogContent id="AddAdminJobTitleDialogContent">
				{isLoading && (
					<div className="loadingSpinnerContainer">
						<CircularProgress color="primary" />
					</div>
				)}
				{!isLoading && (
					<>
						<div className="AddAdminJobTitleDialogRow">
							<Collapse sx={{ flex: 1 }} in={alertOpen}>
								<Alert
									severity="error"
									action={
										<IconButton
											aria-label="close"
											color="inherit"
											size="small"
											onClick={() => setAlertOpen(false)}
										>
											<CloseIcon fontSize="inherit" />
										</IconButton>
									}
								>
									Please select a job title
								</Alert>
							</Collapse>
						</div>
						<div className="AddAdminJobTitleDialogRow">
							<Autocomplete
								sx={{ flex: 1 }}
								options={availableJobTitles}
								getOptionLabel={(opt) => opt.name}
								isOptionEqualToValue={(opt, val) => opt.id === val.id}
								value={selected}
								onChange={(_, val) => setSelected(val)}
								renderInput={(params) => (
									<TextField {...params} label="Job Title" />
								)}
							/>
						</div>
					</>
				)}
				<div className="dialogButtons">
					<Button onClick={handleClose} variant="outlined" color="error">
						Cancel
					</Button>
					<Button onClick={handleSubmit} variant="contained">
						Add
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default AddAdminJobTitleDialog;
